import axios from 'axios'; 

export default axios.create({
    baseURL: process.env.VUE_APP_API_SERVER,
    headers: { 'Cache-Control': 'no-cache' } 
});
console.info("Load connection");